/* @Author: liwen 
 * @Date: 2020-12-Su 05:02:32 
 * @Last Modified by:   liwen  */
import React from "react";
import { Button, Input, Tabs, Tag, Upload, Icon, Checkbox } from "antd";
import Scrollbars from "react-custom-scrollbars";
import { SketchPicker } from "react-color";
import Editors from "../components/editor/Editor";
import BasicProperties from "./basicProperties";
import HistoryRecords from "./historyRecords";
import FlowRecords from "./flowRecords";
import Repository from "./repository";
import ColumnSetting from "./columnSetting";
import SelectResource from "../components/pmsWriting/selectResource/selectResource";
//import fieldsConfig from "./fieldsConfig";
import _ from 'lodash';
import bold from "./images/bold.png";
import italic from "./images/italic.png";
import selectColor from "./images/selectColor.png";
import "./pmsWriting.scss";


const { TabPane } = Tabs;
const { TextArea } = Input;
const tabs = [
    {
        id: "1",
        title: '基本属性'
    },
    {
        id: "2",
        title: '历史记录'
    },
    {
        id: "3",
        title: '流程记录'
    },
    {
        id: "4",
        title: '资源库'
    },
    {
        id: "5",
        title: '栏目设置'
    }
];
// const fieldsConfig = [
//     [
//         {
//            fieldLabel: '作者',
//            fileName: 'author',
//            fieldValue: '',
//            type: 'input',
//            show: true,
//            foldShow: true,   //展开折叠时是否需要展示
//            required: false,
//            content: <div><Input onChange={(e) => this.changeValue(e,'author')}/></div>
//         },
//         {
//            fieldName: '作者联系方式',
//            fieldValue: '',
//            type: 'input',
//            show: true,
//            foldShow: true, //展开折叠时是否需要展示
//            required: false,
//            content: <Input />
//         },
//         {
//            fieldName: '所属部门',
//            fieldValue: '',
//            type: 'input',
//            show: true,
//            foldShow: true, //展开折叠时是否需要展示
//            required: false,
//            content: <Input />
//         }
//     ],
//     [
//         {
//            fieldName: '跳转链接',
//            fieldValue: '',
//            type: 'input',
//            show: true,
//            foldShow: true, //展开折叠时是否需要展示
//            required: false,
//            content: <><Input /><Checkbox/></>
//         },
//     ]
// ];
class PmsWriting extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            activeKey: "1",
            fold: true,
            titles: [],
            params: {
                title: ''
            },
            showColorPicker: false,  //控制选择颜色组件的展示
            color: '',
            titleBold: '',
            titleItalic: '',
            showInputTag: false,
            tags: [], //标签
            fieldsConfig: [
                [
                    {
                        fieldName: '标题',
                        fieldValue: '',
                        type: 'input',
                        show: true,
                        foldShow: true,   //展开折叠时是否需要展示
                        required: false,
                        content: <div className="item-content">
                                     <Input style={{ background: "red", color: this.state && this.state.color, fontWeight: this.state && this.state.titleBold, fontStyle: this.state && this.state.titleItalic }} onChange={(e) => this.changeValue(e,'title')}/>
                                     <div className="item-extra">
                                        <span style={{ padding: '0 5px' }}>0/360</span>
                                        <img src={bold} style={{ width: 16, height: 16, cursor: 'pointer' }} alt="加粗" onClick={this.changeTitleBold} />
                                        <img src={italic} style={{ width: 14, height: 14, cursor: 'pointer', margin: '0 5px' }} alt="斜体" onClick={this.changeTitleItalic} />
                                        <img src={selectColor} style={{ width: 18, height: 18, cursor: 'pointer' }} onClick={() => this.changeColorPickerShow()} alt="颜色" />
                                        {/* <div className="select-color" style={{ display: showColorPicker ? 'inline-block' : 'none' }}>
                                            <SketchPicker color={color} onChange={this.changeColor} type="sketch" />
                                            <div style={{ display: 'flex', justifyContent:'flex-end',paddingRight: 10}} >
                                                <Button size="small" style={{ marginRight: 15}} onClick={() => this.setState({ color: '' })}>清除</Button>
                                                <Button size="small" onClick={() => this.setState({ showColorPicker: false })}>关闭</Button>
                                            </div>
                                        </div> */}
                                         

                                     </div>
                                </div>
                     },
                ],
                [
                    {
                        fieldName: '',
                        fieldValue: '',
                        type: '',
                        show: true,
                        foldShow: true,   //展开折叠时是否需要展示
                        required: false,
                        content: <div className="item-content">
                                     <Checkbox.Group options={['列表标题', '副标题', '引题']} onChange={this.changeTitleTypes} />
                                 </div>
                     },
                ],
                [
                    {
                        fieldName: '列表标题',
                        fieldValue: '',
                        type: '',
                        show: false,
                        foldShow: true,   //展开折叠时是否需要展示
                        required: false,
                        content: <div className="item-content">
                                     <Input onChange={(e) => this.changeValue(e,'title')}/>
                                 </div>
                     },
                ],
                [
                    {
                        fieldName: '副标题',
                        fieldValue: '',
                        type: '',
                        show: false,
                        foldShow: true,   //展开折叠时是否需要展示
                        required: false,
                        content: <div className="item-content">
                                     <Input onChange={(e) => this.changeValue(e,'title')}/>
                                 </div>
                     },
                ],
                [
                    {
                        fieldName: '引题',
                        fieldValue: '',
                        type: '',
                        show: false,
                        foldShow: true,   //展开折叠时是否需要展示
                        required: false,
                        content: <div className="item-content">
                                     <Input onChange={(e) => this.changeValue(e,'title')}/>
                                 </div>
                     },
                ],
                [
                    {
                       fieldName: '作者',
                       fieldValue: '',
                       type: 'input',
                       show: true,
                       foldShow: true,   //展开折叠时是否需要展示
                       required: false,
                       content: <div className="item-content"><Input onChange={(e) => this.changeValue(e,'author')}/></div>
                    },
                    {
                       fieldName: '作者联系方式',
                       fieldValue: '',
                       type: 'input',
                       show: true,
                       foldShow: true, //展开折叠时是否需要展示
                       required: false,
                       content: <div className="item-content"><Input onChange={(e) => this.changeValue(e,'authorContact')}/></div>
                    },
                    {
                       fieldName: '所属部门',
                       fieldValue: '',
                       type: 'input',
                       show: true,
                       foldShow: true, //展开折叠时是否需要展示
                       required: false,
                       content: <div className="item-content"><Input onChange={(e) => this.changeValue(e,'deptartment')}/></div>
                    }
                ],
                [
                    {
                       fieldName: '摄影',
                       fieldValue: '',
                       type: 'input',
                       show: true,
                       foldShow: true,   //展开折叠时是否需要展示
                       required: false,
                       content: <div className="item-content"><Input onChange={(e) => this.changeValue(e,'author')}/></div>
                    },
                    {
                       fieldName: '摄像',
                       fieldValue: '',
                       type: 'input',
                       show: true,
                       foldShow: true, //展开折叠时是否需要展示
                       required: false,
                       content: <div className="item-content"><Input onChange={(e) => this.changeValue(e,'authorContact')}/></div>
                    },
                    {
                       fieldName: '编辑',
                       fieldValue: '',
                       type: 'input',
                       show: true,
                       foldShow: true, //展开折叠时是否需要展示
                       required: false,
                       content: <div className="item-content"><Input onChange={(e) => this.changeValue(e,'deptartment')}/></div>
                    },
                    {
                        fieldName: '来源',
                        fieldValue: '',
                        type: 'input',
                        show: true,
                        foldShow: true, //展开折叠时是否需要展示
                        required: false,
                        content: <div className="item-content"><Input onChange={(e) => this.changeValue(e,'deptartment')}/><div style={{ width: 86}} className="item-extra">【选择来源】</div></div>
                     }
                ],
                [
                    {
                       fieldName: '跳转链接',
                       fieldValue: '',
                       type: 'input',
                       show: true,
                       foldShow: false, //展开折叠时是否需要展示
                       required: false,
                       content: <div className="item-content"><Input onChange={(e) => this.changeValue(e,'linkUrl')}/> <div className="item-extra"><Checkbox/></div></div>
                    },
                ],
                [
                    {
                        fieldName: '关键字',
                        fieldValue: '',
                        type: 'input',
                        show: true,
                        foldShow: false, //展开折叠时是否需要展示
                        required: false,
                        content: <div className="item-content"><Input onChange={(e) => this.changeValue(e,'linkUrl')}/> <div className="item-extra"><Checkbox/></div></div>
                     },

                ],
                [
                    {
                        fieldName: '标签',
                        fieldValue: '',
                        type: 'input',
                        show: true,
                        foldShow: false, //展开折叠时是否需要展示
                        required: false,
                        content: <div className="item-content"><Input onChange={(e) => this.changeValue(e,'linkUrl')}/> <div className="item-extra"><Checkbox/></div></div>
                     },

                ],
                [
                    {
                        fieldName: '内容摘要',
                        fieldValue: '',
                        type: 'input',
                        show: true,
                        foldShow: false, //展开折叠时是否需要展示
                        required: false,
                        content: <div className="item-content"><TextArea rows={4} onChange={(e) => this.changeValue(e,'linkUrl')}/> <div className="item-extra" style={{ alignItems: 'flex-end' }}><Checkbox/></div></div>
                     },
                ],
                [
                    {
                        fieldName: '附件管理',
                        fieldValue: '',
                        type: 'input',
                        show: true,
                        foldShow: false, //展开折叠时是否需要展示
                        required: false,
                        content: <div className="item-content"><Upload listType="picture-card"><Icon type="upload" />点击上传</Upload></div>
                     },
                ]
            ]
        }
    }

    //设置标题样式
    changeColorPickerShow = () => {
        this.setState(() => {
            return {
                showColorPicker: true
            }
        })
    }

    changeTitleBold = () => {
        console.log('进入了这个方法呀')
        if (this.state.titleBold) {
            this.setState(() => {
                return {
                    titleBold: ''
                }
            })
        } else {
            this.setState(() => {
                return {
                    titleBold: 'bold'
                }
            })
        }
    }

    changeTitleItalic = () => {
        if (this.state.titleItalic) {
            this.setState(() => {
                return {
                    titleItalic: ''
                }
            })
        } else {
            this.setState(() => {
                return {
                    titleItalic: 'italic'
                }
            })
        }
    }

    changeColor = (color) => {
        this.setState(() => {
            return {
                color: color.hex,
                //showColorPicker: false
            }
        })
    }

    //标题类型
    changeTitleTypes = (checkedValues) => {
       let  arr  =  _.cloneDeep(this.state.fieldsConfig);
         //标题类型选择 决定是否渲染 ['列表标题', '副标题', '引题']
     
            if(Array.isArray(arr)){
                for(let i=0; i<arr.length; i++){
                    for(let j=0; j<arr[i].length; j++){
                        if(arr[i][j].fieldName === '列表标题'){
                           let index = checkedValues.indexOf('列表标题')
                           arr[i][j].show = index > -1 ? true : false
                            this.setState({
                                fieldsConfig: arr
                            });
                            break;
                        }
                        if(arr[i][j].fieldName === '副标题'){
                            let index = checkedValues.indexOf('副标题')
                            arr[i][j].show = index > -1 ? true : false
                             this.setState({
                                 fieldsConfig: arr
                             });
                             break;

                        }
                        if(arr[i][j].fieldName === '引题'){
                            let index = checkedValues.indexOf('引题')
                            arr[i][j].show = index > -1 ? true : false
                             this.setState({
                                 fieldsConfig: arr
                             });
                             break;
                        }
                    }
                }
            }
    }


    //标签 事件
    changeTagInput = () => {
        this.setState({
            showInputTag: true
        }, () => {
            this.inputRef.focus();
        })
    }

    addTag = (e) => {
        let tags = this.state.tags;
        let tag = e.target.value;
        if (tag && tags.indexOf(tag) === -1) {
            tags.push(tag)
        }
        this.setState(() => {
            return {
                tags,
                showInputTag: false,
            }
        })
    }

    //跳转链接  复选框的点击事件
    changeLink = () => {

    }

    //关键字  复选框的点击事件
    changeKeyWordsChecked = () => {

    }

    //内容摘要 复选框的点击事件
    changeContentSummaryChecked = () => {

    }

    //右边侧边栏
    renderTabContent = () => {
        const { activeKey } = this.state;
        switch (activeKey) {
            case '1': return <BasicProperties />;
            case '2': return <HistoryRecords />;
            case '3': return <FlowRecords />;
            case '4': return <Repository />;
            case '5': return <ColumnSetting />;
            default: break;
        }
    }

    //右边侧边栏选项卡的onChange事件
    changeActiveKey = (activeKey) => {
        this.setState({
            activeKey
        })
    }

    //input框的onChange事件
    changeValue = (e, paramsName) => {
        let params = this.state.params;
        params[paramsName] = e.target.value;
        this.setState(() => {
            return {
                params
            }
        })
    }

    //字段 展开或折叠
    collapse = () => {
        this.setState({
            fold: !this.state.fold
        })
    }

    renderType = (item, childItem, childIndex) => {
        const { fold } = this.state;
        console.log('走进了render方法')
        if(childItem.fieldName === '标题'){
            console.log(childItem)
        }
        if(childItem.show){
            return(
                <div className={`item ${ fold ? (childItem.foldShow ? '' : 'fold') :''}`} key={childIndex} style={{ width: `calc( ( 100% - ${10*(item.length-1)}px ) / ${ item.length })`}}>
                    <div className="item-label">
                        <span className="item-title">{childItem.fieldName}</span>
                        <span className="item-colon">{childItem.fieldName ? '：' : ''}</span>
                    </div>
                    {childItem.content}
                </div>
            )
        }
    }
  

    render() {
        let height = window.innerHeight - 91;
        const { activeKey, fold, titles, params, showColorPicker, color, titleBold, titleItalic, showInputTag, tags, fieldsConfig } = this.state;
        return (
            <div className="pms-writing" style={{ height }}>
                <div className="pms-writing-operate">
                    <Button type="primary">保存</Button>
                    <Button type="primary">发布</Button>
                    <Button >浏览</Button>
                    <Button >锁定编辑</Button>
                </div>
                <Scrollbars style={{ height: 'calc( 100% - 62px )' }}>
                    <div className="pms-writing-wrap">

                        <div className="pms-writing-wrap-left">
                            <div className="pms-writing-wrap-left-options">
                                {
                                    fieldsConfig.map((item, index) => {
                                        return (
                                            <div className="box" key={index}>
                                                {
                                                    item.map((childItem, childIndex) =>  this.renderType(item,childItem,childIndex))
                                                }
                                            </div>
                                        )
                                    })
                                }
                                {/* <div className="box title-name" >
                                    <div className="item">
                                        <span className="item-title">标&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;题&nbsp;：</span>
                                        <Input value={params.title} style={{ color: color, fontWeight: titleBold, fontStyle: titleItalic }} placeholder="请输入标题" onChange={(e) => this.changeValue(e, 'title')} />
                                        <span style={{ padding: '0 5px' }}>{params.title.length}/360</span>
                                        <img src={bold} style={{ width: 16, height: 16, cursor: 'pointer' }} alt="加粗" onClick={this.changeTitleBold} />
                                        <img src={italic} style={{ width: 14, height: 14, cursor: 'pointer', margin: '0 5px' }} alt="斜体" onClick={this.changeTitleItalic} />
                                        <img src={selectColor} style={{ width: 18, height: 18, cursor: 'pointer' }} onClick={() => this.changeColorPickerShow()} alt="颜色" />
                                        <div className="select-color" style={{ display: showColorPicker ? 'inline-block' : 'none' }}>
                                            <SketchPicker color={color} onChange={this.changeColor} type="sketch" />
                                            <div style={{ display: 'flex', justifyContent:'flex-end',paddingRight: 10}} >
                                                <Button size="small" style={{ marginRight: 15}} onClick={() => this.setState({ color: '' })}>清除</Button>
                                                <Button size="small" onClick={() => this.setState({ showColorPicker: false })}>关闭</Button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="item">
                                        <Checkbox.Group options={['列表标题', '副标题', '引题']} onChange={this.changeTitleTypes} />
                                    </div>
                                </div>
                                {
                                    titles.map((item, index) => (
                                        <div className={`box ${item === '列表标题' ? 'column-title' : (item === '副标题' ? 'sub-title' : 'head-title')}`} key={index}>
                                            <div className="item">
                                                {
                                                    item === '列表标题' ? <span className="item-title">列表标题 ：</span> : (item === '副标题' ? <span className="item-title">副&nbsp;&nbsp;标&nbsp;&nbsp;题：</span> : <span className="item-title">引&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;题&nbsp;:</span>)
                                                }
                                                <Input placeholder={`请输入${item}`} />
                                            </div>
                                        </div>
                                    ))
                                }
                                <div className="box author">
                                    <div className="item">
                                        <span className="item-title">作&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;者&nbsp;：</span>
                                        <Input placeholder="请输入作者" />
                                    </div>
                                    <div className="item">
                                        <span className="item-title">作者联系方式 ：</span>
                                        <Input placeholder="作者联系方式" />
                                    </div>
                                    <div className="item">
                                        <span className="item-title">所属部门 ：</span>
                                        <Input placeholder="所属部门" />
                                    </div>
                                </div>
                                <div className="box picture">
                                    <div className="item">
                                        <span className="item-title">摄&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;影&nbsp;：</span>
                                        <Input placeholder="" />
                                    </div>
                                    <div className="item">
                                        <span className="item-title">摄像 ：</span>
                                        <Input placeholder="" />
                                    </div>
                                    <div className="item">
                                        <span className="item-title">编辑 ：</span>
                                        <Input placeholder="" />
                                    </div>
                                    <div className="item">
                                        <span className="item-title">来源 ：</span>
                                        <Input placeholder="" />
                                        <span onClick={()=> this.selectResource.showSelectResource()}>【选择来源】</span>
                                    </div>
                                </div>
                                <div className="box link">
                                    <div className="item">
                                        <span className="item-title">跳转链接 ：</span>
                                        <Input placeholder="" />
                                        <div className="checkbox">
                                            <Checkbox onChange={this.changeLink}></Checkbox>
                                        </div>
                                    </div>
                                </div>
                                <div className={`${fold ? 'fold' : ''} box keyWords`} >
                                    <div className="item">
                                        <span className="item-title">关&nbsp;&nbsp;键&nbsp;&nbsp;字：</span>
                                        <Input placeholder="" />
                                        <div className="checkbox">
                                            <Checkbox onChange={this.changeKeyWordsChecked}>自动提取</Checkbox>
                                        </div>
                                    </div>
                                </div>
                                <div className={`${fold ? 'fold' : ''} box tags`}>
                                    <div className="item">
                                        <span className="item-title">标&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;签&nbsp;：</span>
                                        {
                                            tags.map((tag, index) => <Tag style={{ height: 32, display: 'flex', alignItems: 'center' }} closable key={tag}>{tag}</Tag>)
                                        }
                                        {
                                            showInputTag ? <Input ref={(input) => this.inputRef = input} onPressEnter={this.addTag} /> : <Tag style={{ height: 32, display: 'flex', alignItems: 'center' }} onClick={this.changeTagInput}>  <Icon type="plus" style={{ marginRight: 3 }} />新增标签</Tag>

                                        }
                                    </div>
                                </div>
                                <div className={`${fold ? 'fold' : ''} box contentSummary`}>
                                    <div className="item">
                                        <span className="item-title">内容摘要 ：</span>
                                        <TextArea rows={4} />
                                        <div className="checkbox">
                                            <Checkbox onChange={this.changeContentSummaryChecked}>自动提取</Checkbox>
                                        </div>
                                    </div>
                                </div>
                                <div className="box attachment">
                                    <div className="item">
                                        <span className="item-title" style={{ width: 74 }}>附件管理 ：</span>
                                        <div className="item-content">
                                            <Upload >
                                                <Button>
                                                    <Icon type="upload" /> 点击上传
                                        </Button>
                                            </Upload>
                                        </div>

                                    </div>
                                </div>
                                <div className={`${fold ? 'fold' : ''} box title-picture`}>
                                    <div className="item">
                                        <span className="item-title">标&nbsp;&nbsp;题&nbsp;&nbsp;图：</span>
                                        <div className="upload" >
                                            <Upload listType="picture-card">
                                                {}
                                            </Upload>
                                        </div>
                                    </div>
                                </div> */}
                                <span style={{ display: 'inline-block', width: '100%', textAlign: 'right', cursor: 'pointer' }} onClick={this.collapse}> 展开</span>
                            </div>
                            <div className="pms-writing-wrap-left-editor">
                                <Editors
                                    content={this.state.content}
                                    isUpDate={this.state.isUpDate}
                                    imgBtnShow={true}
                                    xiuMiBtnShow={true}
                                    wordImportBtnShow={true}
                                    oneTypesettingBtnShow={true}
                                    /* stuffId={this.state.stuffList[this.state.currentItemIndex]&&this.state.stuffList[this.state.currentItemIndex].id?this.state.stuffList[this.state.currentItemIndex].id:0}
                                     xiumiIdCallBack={(id)=>{
                                         console.log('秀米id',id);
                                         this.state.stuffList[this.state.currentItemIndex].fromId=id;
                                         let params = {id: this.state.materialId,mediaCode: this.props.mediaCode,stuffList:this.state.stuffList,isAdd:this.state.isAdd};
                                         savePicAndArt(params,(res) => {
                                             if(res&&res.data&&res.data.id){
                                                 this.state.stuffList[this.state.currentItemIndex].id=res.data.stuffList[this.state.currentItemIndex].id;
                                                 this.state.stuffList.forEach(item=>{
                                                     item.materialId=res.data.id;
                                                 });//给每一条stuff数据都加上materialId
                                                 this.setState({materialId:res.data.id})
                                             }
                                             console.log('秀米返回数据保存')
                                         });
                                         this.setState({})
                                     }}*/
                                    callBackeditorContent={(data) => {
                                        console.log(data)
                                    }}
                                />
                            </div>

                        </div>
                        <div className="pms-writing-wrap-right">

                            <Tabs size="small" activeKey={activeKey} onChange={this.changeActiveKey}>
                                {
                                    tabs.map((item) => (
                                        <TabPane key={item.id} tab={item.title}></TabPane >
                                    ))
                                }
                            </Tabs>
                            <div className="pms-writing-wrap-right-content">
                                {this.renderTabContent()}
                            </div>

                        </div>
                    </div>
                </Scrollbars>
                <SelectResource ref = {(select) => this.selectResource = select}/>
            </div>
        )
    }
}

export default PmsWriting;